import React from "react";
import Card from "../card";
import { Button } from "../../atoms";

const toneStyles = {
  default: {
    frame: "",
    badge: "text-slate-700",
    subtitle: "text-slate-600",
  },
  error: {
    frame: "",
    badge: "text-amber-700",
    subtitle: "text-slate-500",
  },
};

const EmptyState = ({
  title,
  subtitle,
  action,
  illustration,
  illustrationAlt,
  badge,
  tone = "default",
}) => {
  const currentTone = toneStyles[tone] || toneStyles.default;

  return (
    <Card className="w-full">
      <div className="flex w-full flex-col items-center justify-center gap-4 py-2 text-center sm:gap-5">
        {illustration && (
          <div
            className={`flex w-full max-w-[260px] items-center justify-center px-4 py-2 ${currentTone.frame}`}
          >
            <img
              src={illustration}
              alt={illustrationAlt || title || "Estado vacio"}
              className="w-full h-auto max-w-[220px] select-none"
            />
          </div>
        )}
        {badge && (
          <span
            className={`text-xs font-bold uppercase tracking-[0.16em] ${currentTone.badge}`}
          >
            {badge}
          </span>
        )}
        <span className="max-w-[18ch] text-xl font-bold leading-tight text-center text-slate-950">
          {title || "No hay data disponible"}
        </span>
        <span className={`max-w-[32ch] text-sm font-normal leading-6 text-center ${currentTone.subtitle}`}>
          {subtitle || "Vuelva a intentarlo mas tarde"}
        </span>
        {action && <Button onClick={action}>Regresar</Button>}
      </div>
    </Card>
  );
};

export default EmptyState;
